import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router} from '@angular/router';
import { Injectable } from '@angular/core';
import {first, map} from 'rxjs/operators';
import { Observable } from 'rxjs';

import { BasicSettingsService } from '../basic-settings/shared/basic-settings.service';

@Injectable()
export class GroupListResolver implements Resolve<any> {
    constructor(
        private basicSettingService: BasicSettingsService,
        private router: Router,
    ) {}
  
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this.basicSettingService.getGroupList().pipe(map((result: any) => {
            if (result.hasOwnProperty('success') && result.success === false) {
                return null;
            }
            return result;
        }),first(),);
    }
  }
